"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _QueryContext = _interopRequireDefault(require("../../ThemeProvider/QueryContext"));

var _useMediaQueryContext = _interopRequireDefault(require("../../ThemeProvider/QueryContext/useMediaQueryContext"));

var useMediaQuery = function useMediaQuery() {
  var media = React.useContext(_QueryContext.default);
  var value = (0, _useMediaQueryContext.default)();

  if (media != null && Object.values(media).some(function (v) {
    return v != null;
  })) {
    return media;
  }

  return value;
};

var _default = useMediaQuery;
exports.default = _default;